import { axiosInstance } from "@/api/axiosInstance"

export const getCategories = async () => {
    const response = await axiosInstance.get("/api/categories")
    return response.data
}

export const getProducts = async (params?: {
    page?: number
    size?: number
    categoryId?: number
    sort?: string
}) => {
    const response = await axiosInstance.get("/api/products", { params })
    return response.data
}

export const getProductDetail = async (productId: number | string) => {
    const response = await axiosInstance.get(`/api/products/${productId}`)
    return response.data
}

// 고객용 상품 목록 조회 (ProductController 연동)
export const getPublicProducts = async (params?: { page?: number; size?: number; keyword?: string; categoryId?: number; sort?: string; mainExposureYn?: string; bestYn?: string }) => {
    try {
        const response = await axiosInstance.get(`/api/products`, { params });
        // ApiResponse 객체 구조에 따라 분기 처리
        return response.data;
    } catch (error) {
        console.error("상품 목록 조회 에러:", error);
        return { data: { items: [] } }; // 에러 시 빈 배열 처리
    }
};

// 고객용 상품 상세 조회
export const getPublicProductDetail = async (productId: string | number) => {
    try {
        const response = await axiosInstance.get(`/api/products/${productId}`);
        return response.data;
    } catch (error) {
        console.error("상품 상세 조회 에러:", error);
        throw error;
    }
};